import useSWR from "swr";
import useSWRFetcher from "./commonly-stored/fetcher";
import { VersionResponse } from "../../pages/api/version";
import settings from "../../constants/settings";

export enum CodeVersionStatus {
  UNCERTAIN,
  OUT_OF_DATE,
  LATEST,
}

export default function useCodeVersionStatus() {
  const fetcher = useSWRFetcher<VersionResponse>();
  const { data } = useSWR("/api/version", fetcher);
  if (data === undefined) {
    return CodeVersionStatus.UNCERTAIN;
  }
  return data.version == settings.gitCommitSha
    ? CodeVersionStatus.LATEST
    : CodeVersionStatus.OUT_OF_DATE;
}
